<!-- <div class="row">
    <div class="col-12">
        <div class="blog-header-container">
            <div class="row">
                <div
                    class="col-12 mt-5 pt-5 d-flex justify-content-center align-items-center"
                >
                    <h2 class="mt-5 pt-5">Crowdsale blog</h2>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12 text-center">
                    <button
                        nbButton
                        size="small"
                        status="primary"
                        appearance="ghost"
                        (click)="onBackToCrowdsale()"
                    >
                        BACK TO CROWDSALE
                    </button>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="container">
  <div class="row">
    <div class="col-7 offset-2 mt-5 d-flex justify-content-center">
      <img [src]="articleData?.image" width="768" />
    </div>
  </div>
  <div class="row" *ngIf="articleData">
    <div class="col-7 offset-2 mt-5">
      <h2>{{ articleData?.title }}</h2>
    </div>
    <div class="col-4 text-right">
      <span
        class="badge rounded-pill bg-secondary"
        style="color: #fff"
        *ngFor="let tag of articleData?.tags"
        >{{ tag }}</span
      >
    </div>
  </div>
  <div class="row" *ngIf="articleData">
    <div class="col-7 offset-2 d-flex align-items-center">
      <p class="mb-0 mr-2">
        {{ articleData.author }} -
        <span class="italic">{{ articleData?.createdAt | date }}</span>
      </p>
      <span
        class="badge rounded-pill bg-primary ml-2"
        style="color: #fff"
        *ngFor="let category of articleData?.categories"
        >{{ category }}</span
      >
    </div>
  </div>
  <div class="row mt-2 mb-5" *ngIf="articleData">
    <div class="col-7 offset-2" [innerHtml]="articleData?.text"></div>
  </div>
  <div class="row mb-5" *ngIf="articleNotFound">
    <div class="col-12 text-center">
      <h3>The article you are trying to reach no longer exists!</h3>
    </div>
  </div>
</div>
